<template>
  <div>
    <!-- 検索入力 -->
    <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}" v-if="step === 0&&!isLoading">
      <div
        class="message"
        :style="{
        'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important',
        'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
        'filter': shadowStyle(color.shadowType)}"
      >
        <div class="question-button-wrapper">
          <QuestionButton @click.native="active = true" />
        </div>
        <button
          class="button is-small is-danger"
          style="position: absolute; top: 8px; right: 8px;"
          @click.once="pushSelect('検索を終了', isBot, 0)"
          :disabled="isNowButton()"
        >
          検索を終了
        </button>
        <p class="message-title">{{ messageEscape(parameter.message) }}</p>
        <div style="display: flex;">
          <input class="input is-small" v-model="searchWord" :disabled="isNowButton()"/>
          <button
            class="button is-info send-button is-small"
            @click="search()"
            :disabled="!searchWord||isNowButton()">
            <span class="mdi mdi-magnify"></span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="isLoading">
      <span class="mdi mdi-spin mdi-loading mdi-48px" ></span>
    </div>
    
    <!-- 検索結果 -->
    <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}" v-else-if="step === 1">
      <div
        class="message"
        :style="{
        'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important',
        'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
        'filter': shadowStyle(color.shadowType)}">
        <template v-if="searchFilter.length > 0">
          <template v-for="(s, idx) in searchFilter">
            <div class="search-box" :key="idx" v-if="idx === index">
              <section class="left-section">
                <div>
                  <p class="message-title"><b>{{ messageEscape(s.title) }}</b></p>
                  <p class="message-desc">{{ messageEscape(s.description) }}</p>
                </div>
                <template v-if="s.type === 1">
                  <div>
                    <a class="button is-small is-primary" :href="addUserIDIfRobo(s.url)" target="_blank" rel="noopener">ページを開く</a>
                  </div>
                </template>
                <template v-else-if="s.type === 2">
                  <div>
                    <button class="button is-small is-primary" @click="nextSubscribeView(s.renkeiID)">応募する</button>
                  </div>
                </template>
                <div class="search-footer">
                  <button class="button is-small" @click="backIndex()" :disabled="index === 0">戻る</button>
                  <button class="button is-small" @click="nextIndex()" :disabled="index === searchFilter.length - 1">次へ</button>
                  <p>{{index + 1}} / {{searchFilter.length}}</p>
                </div>
                <div v-if="!parameter.is_search">
                  <button class="button is-small" @click="backSearch()">検索に戻る</button>
                </div>
              </section>
              <section class="right-section">
                <div v-if="s.image_ref" class="right-section-contents">
                  <img :src="s.image_ref.image_data">
                </div>
              </section>
              <button class="button is-small is-danger" style="position: absolute; top: 8px; right: 8px;" @click.once="pushSelect('検索を終了', isBot, 0)">検索を終了</button>
            </div>
          </template>
        </template>
        <template v-else>
          <button class="button is-small is-danger" style="position: absolute; top: 8px; right: 8px;" @click.once="pushSelect('検索を終了', isBot, 0)">検索を終了</button>
          <p class="message-title">お探しの内容が見つかりませんでした。</p>
          <div v-if="!parameter.is_search">
            <button class="button is-small" @click="backSearch()">検索に戻る</button>
          </div>
        </template>
      </div>
    </div>
    <!-- 応募 -->
    <CVParts
      :message="message"
      :speaker="speaker"
      :color="color"
      :skInfo="skInfo"
      :isDemo="isDemo"
      :logIndex="logIndex"
      :lastIndex="lastIndex"
      :companyData="companyData"
      :renkeiID="renkeiID"
      @subscribe="subscribe"
      @initScenario="search"
      v-else-if="step === 2"
    />
    <ModalSearchQA :active="active" @cancel="cancelModalSearchQA" />
  </div>
</template>

<script>
import hex2rgb from "@/functions/hex2rgb"
import CVParts from '@/components/BalloonParts/CVParts'
import ModalSearchQA from '@/components/organisms/modals/ModalSearchQA'
import QuestionButton from '@/components/atoms/buttons/QuestionButton'
import tools   from '@/api/tools'

// 外部関数
import {
  autoColor,
  shadowStyle,
  isNowButton,
  messageEscape,
} from "@/functions/balloonFunc"

export default {
  name: "SearchParts",
  props: ['message', 'speaker', 'color', 'lastIndex', 'logIndex', 'parameter', 'isBot', 'skInfo', 'isDemo', 'companyData', 'renkeiID', 'roboArguments'],
  components: {
    CVParts,
    ModalSearchQA,
    QuestionButton
  },
  data () {
    return {
      step: 0,
      searchWord: null,
      index: 0,
      searchFilter: [],
      active: false,
      isLoading: false,
    }
  },
  mounted() {
    this.assignDefaultSearchWord(this.parameter.default_search_word)
    this.defaultSearch()
  },
  methods: {
    cancelModalSearchQA () {
      this.active = false
    },
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    messageEscape (m) {
      return messageEscape(m, this.roboArguments)
    },
    subscribe () {
      this.step = 0
      this.index = 0
      this.searchWord = null
      this.$emit('subscribe')
    },
    pushSelect (m, isBot, btnIndex) {
      this.step = 0
      this.index = 0
      this.searchWord = null
      this.$emit('pushSelect', m, isBot, btnIndex)
    },
    toggleScreen () {
      this.toggleFlg = !this.toggleFlg
    },
    displayBirthday (birthday) {
      if (birthday === null) {
        return ''
      } else {
        return birthday.getFullYear() + '/' + (birthday.getMonth() + 1) + '/' + birthday.getDate()
      }
    },
    search () {
      this.getSearchFilter()
      this.$emit('setRenkeiID', null)
      this.isLoading = true
    },
    nextSubscribeView (renkeiID) {
      this.$emit('setRenkeiID', renkeiID)
      this.step = 2
    },
    backSearch () {
      this.step = 0
      this.index = 0
      this.searchWord = null
      this.searchFilter = []
    },
    backIndex () {
      if (this.index === 0) {
        alert('これ以上は戻れません。')
        return
      } else {
        this.index --
      }
    },
    nextIndex () {
      if (this.index === this.searchFilter.length - 1) {
        alert('これ以上は次へは進めません。')
        return
      } else {
        this.index ++
      }
    },
    assignDefaultSearchWord(searchWord) {
      if (searchWord) {
        this.searchWord = this.messageEscape(searchWord)
     }
    },
    defaultSearch() {
      if (this.parameter.is_search && this.searchWord.length > 0) {
        this.search()
      }
    },
    getSearchFilter () {
      tools.fullSearch({
        words: this.searchWord,
        doc: this.parameter.search
      }).then((ret) => {
        this.searchFilter = ret.data.map((v) =>
          this.parameter.search[v]
        )
        this.step = 1
        this.isLoading = false
      })
    },
    addUserIDIfRobo (next_url) {
      const nowHasID = Boolean(this.$route.query.id)
      const nextIsRobo = new URL(next_url).pathname.split('/')[1] === 'single'
      const nextHasID = new URLSearchParams(new URL(next_url).search).has('id')

      if (nowHasID && nextIsRobo && !nextHasID) {
        return next_url + '?id=' + this.$route.query.id
      }
      return next_url
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  white-space: pre-wrap;
  transition: 0.7s;
  position: relative;
}
.message-title {
  filter: none;
  font-size: 14px;
  margin-bottom: 5px;
  margin-top: 5px;
  white-space: pre-wrap;
  text-align: left;
}
.message-desc {
  filter: none;
  font-size: 13px;
  margin-bottom: 5px;
  white-space: pre-wrap;
  text-align: left;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.input-on {
  font-size: 14px;
  width: calc(100% - 40px);
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-on-tel {
  font-size: 14px;
  width: calc(100% - 40px);
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-on-num {
  font-size: 14px;
  width: 64px;
  margin-bottom: 8px;
}
.input-on-body {
  font-size: 14px;
  width: calc(100% - 40px);
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  margin-bottom: 8px;
}
// Chrome、Safari
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
// Firefox、IE
input[type="number"] {
  -moz-appearance:textfield;
}
.input-off {
  font-size: 14px;
  width: 100%;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.send-button {
  width: 40px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.search-box {
  display: flex;
  flex-wrap: wrap;
}
.search-footer {
  display: flex;
  align-items: center;
  margin-top: 4px;
  p {
    margin-left: 8px;
  }
}
.left-section {
  width: 50%;
  min-width: 144px;
}
.right-section {
  margin-top: 40px;
  width: 50%;
  display: flex;
  justify-content: center;
}
.right-section-contents {
  img {
    margin-top: 8px;
    object-fit: cover;
  }
}
.question-button-wrapper {
  position: absolute;
  top: 8px;
  right: 104px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/SearchParts.vue